import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDataNew as DynamicFetchNew, addData } from '../../Redux/Slices/Transaction/DynamicSlice';
import { AlertPopup } from '../../Asset/common';

/**
 * Reusable "Place Offer" modal component.
 * Call it from anywhere by passing:
 *  - show          : boolean (controls visibility)
 *  - onHide        : function (called on Cancel / close / after submit)
 *  - selectedRows  : array of selected packet rows (must contain PKTID and SELECTED)
 *  - refreshData   : optional function, called after successful submit
 *  - menuCode      : optional, ColumnConfig MenuCode to use for table columns (default 'OFFERPLACE')
 *
 * Example:
 *  <PktPlaceOfferComp
 *      show={showOfferModal}
 *      onHide={() => setShowOfferModal(false)}
 *      selectedRows={Selectedrow}
 *      refreshData={props.refreshData}
 *  />
 */
function PktPlaceOfferComp(props) {
    const { show, onHide, selectedRows, refreshData, menuCode } = props;

    const dispatch = useDispatch();
    const columnConfigRecord = useSelector(state => state.ColumnConfig.visible);
    const DropDown = useSelector(state => state.DropDown);
    const [UserAcCode, setUserAcCode] = useState(0);

    const [OfferColConfig, setOfferColConfig] = useState([]);
    const [offerData, setOfferData] = useState([]);
    const [offerNote, setOfferNote] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setOfferColConfig(columnConfigRecord?.filter(x => x.MenuCode == (menuCode || 'OFFERPLACE')));
    }, [columnConfigRecord, menuCode]);

    useEffect(() => {
        if (show) {
            fetchOfferData();
        } else {
            setOfferData([]);
            setOfferNote('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    useEffect(() => {
        if (DropDown.USERS) {
            let UserRole = DropDown.USERS.find(x => x.UserName == JSON.parse(localStorage.getItem('loginUserDetail'))?.UserName);
            if (UserRole) {
                setUserAcCode({ Code: UserRole.AC_CODE })
            }
        }

    }, [DropDown]);

    const fetchOfferData = async () => {
        console.log('Offer selectedRows', selectedRows);

        let pktidArray = Array.isArray(selectedRows) && selectedRows?.filter(obj => obj.SELECTED == true && obj.PKTID)?.map(obj => obj.PKTID);

        if (!pktidArray || pktidArray.length === 0) {
            AlertPopup.warningPopup("Please Select atleast one Record !!");
            if (onHide) onHide();
            return;
        }

        debugger
        const updatedData = pktidArray?.map(item => ({
            PKTID: item
        }));

        let ObjJsonDet = {
            jsonObj1: updatedData,
            SPName: "API_OfferEntPenDisp"
        };

        setLoading(true);
        try {
            let response = await DynamicFetchNew(ObjJsonDet);
            const rows = (response || [])?.map(row => ({
                ...row,
                OFF_DISC: '',
                OFF_RATE: ''
            }));
            setOfferData(rows);
        } catch (error) {
            AlertPopup.errorPopup(error);
        } finally {
            setLoading(false);
        }
    };

    const handleOfferSubmit = async () => {
        if (!offerData || offerData.length === 0) {
            AlertPopup.warningPopup("No stones available to offer !!");
            return;
        }

        const hasOffer = offerData?.some(row =>
            (row.OFF_DISC == "" &&
                row.OFF_DISC == null &&
                row.OFF_DISC == 0 &&
                row.OFF_DISC == undefined) ||
            (row.OFF_RATE == "" &&
                row.OFF_RATE == null &&
                row.OFF_RATE == 0 &&
                row.OFF_RATE == undefined)
        );

        if (!hasOffer) {
            alert("Please enter Offer % or Offer Rate for at least one stone.");
            return;
        }

        debugger
        let jsonObj1 = offerData?.map(row => ({
            ...row,
            PKTID: row.PKTID,
            OFF_DISC: row.OFF_DISC,
            OFF_RATE: row.OFF_RATE,
            NOTE: offerNote,
            P_CODE: UserAcCode?.Code || 0,
            TRNTYP: 'WEBOFFER'
        }));

        let ObjJsonDet = {
            jsonObj1: jsonObj1,
            SPName: "API_OfferEntSave"
        };

        await dispatch(addData(ObjJsonDet)).then(() => {
            if (onHide) onHide();
            if (refreshData) {
                refreshData();
            }
        });
    };

    const handleOfferInputChange = (rowIndex, field, value) => {
        setOfferData(prev => {
            const updated = [...prev];

            const row = { ...updated[rowIndex] };

            row[field] = value;

            const orate = Number(row.ORATE || 0);

            if (field === "OFF_DISC") {
                const offDisc = Number(value || 0);

                if (orate > 0) {
                    row.OFF_RATE = (
                        orate - (orate * offDisc / 100)
                    ).toFixed(2);
                }
            }

            if (field === "OFF_RATE") {
                const offRate = Number(value || 0);

                if (orate > 0) {
                    row.OFF_DISC = (
                        ((orate - offRate) / orate) * 100
                    ).toFixed(2);
                }
            }

            updated[rowIndex] = row;

            return updated;
        });
    };

    return (
        <Modal show={show} onHide={onHide} size='lg' centered className='offer-modal'>
            <Modal.Header closeButton>
                <Modal.Title>Place Offer</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className='mb-3'>
                    <Form.Label className='fw-bold'>Note</Form.Label>
                    <Form.Control
                        as='textarea'
                        rows={2}
                        placeholder='Enter Note'
                        value={offerNote}
                        onChange={(e) => setOfferNote(e.target.value)}
                    />
                </Form.Group>
                <div className='table-responsive' style={{ maxHeight: '350px', overflowY: 'auto' }}>
                    <table className='table table-bordered mb-0'>
                        <thead className='table-light'>
                            <tr>
                                {
                                    OfferColConfig && OfferColConfig?.length > 0
                                        ? OfferColConfig?.filter(col => !col.IsHide)?.map((col) => (
                                            <th key={col.field}>{col.title || col.field}</th>
                                        ))
                                        : <>
                                            <th>Stock ID</th>
                                            {/* <th>Orate</th> */}
                                            <th>Disc%</th>
                                            <th>Rate</th>
                                        </>
                                }
                                <th>Offer%</th>
                                <th>Offer Rate</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                offerData?.map((row, index) => (
                                    <tr key={row.PKTID || index}>
                                        {
                                            OfferColConfig && OfferColConfig?.length > 0
                                                ? OfferColConfig?.filter(col => !col.IsHide)?.map((col) => {
                                                    const value = row[col.field];
                                                    const displayValue = col.dataType === 'Number' && (value || value === 0)
                                                        ? Number(value).toFixed(2)
                                                        : (value ?? '');
                                                    return <td key={col.field}>{displayValue}</td>;
                                                })
                                                : <>
                                                    <td>{row.PKTID}</td>
                                                    {/* <td>{row.ORATE != undefined ? Number(row.ORATE).toFixed(2) : ''}</td> */}
                                                    <td>{row.DISC != undefined ? Number(row.DISC).toFixed(2) : ''}</td>
                                                    <td>{row.RATE != undefined ? Number(row.RATE).toFixed(2) : ''}</td>
                                                </>
                                        }
                                        <td>
                                            <Form.Control
                                                size='sm'
                                                type='number'
                                                placeholder='Offer%:'
                                                value={row.OFF_DISC}
                                                onChange={(e) => handleOfferInputChange(index, 'OFF_DISC', e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                size='sm'
                                                type='number'
                                                placeholder='$/CTS.'
                                                value={row.OFF_RATE}
                                                onChange={(e) => handleOfferInputChange(index, 'OFF_RATE', e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                ))
                            }
                            {
                                (!offerData || offerData.length === 0) && (
                                    <tr>
                                        <td colSpan={5} className='text-center text-muted'>
                                            {loading ? 'Loading...' : 'No stones found'}
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
                <div className='text-danger small mt-2'>
                    <strong>Note:</strong> Submit an offer at your preferred price. Our sales team will review it and approve it if Possible.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type='button' className='btn btn-outline-primary' onClick={onHide}>Cancel</button>
                <button type='button' className='btn btn-primary' onClick={handleOfferSubmit}>Submit</button>
            </Modal.Footer>
        </Modal>
    );
}

export default PktPlaceOfferComp;